// theme.js
import { createTheme } from '@mui/material/styles';

export const customTheme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: {
      main: '#1976d2', 
    },
    background: {
      default: '#f4f6f8',
    },
  },
});
